import BaseDataObject from './BaseDataObject';

export default class SavedTemplateSet extends BaseDataObject {
  constructor(data) {
    super(Array.isArray(data) ? { savedTemplates: data } : data);
  }

  getNumberOfSavedTemplates() {
    return this.getNumberOf('savedTemplates');
  }

  getSavedTemplate(index) {
    return this.getObject('savedTemplates', SavedTemplate, index);
  }
}

class SavedTemplate extends BaseDataObject {
  getID() {
    return this.getInteger('id');
  }

  getName() {
    return this.getString('name');
  }

  isGlobal() {
    return this.getBoolean('global');
  }

  getBetType() {
    return this.getString('betType');
  }

  getDisplayName() {
    return `${this.getBetType()}-${this.getName()}`;
  }

  getReductions() {
    return this.getBoolean('reductions');
  }

  getMarks() {
    return this.getBoolean('marks');
  }

  getCreatedTime() {
    return this.getDate('createdAt');
  }

  getModifiedTime() {
    return this.getDate('modifiedAt');
  }
}
